import {
  Permission,
  PermissionCreateRequest,
  PermissionUpdateRequest,
} from '../../types/app/permission.types';
import { api } from '../core/api';

export const getPermissionList = () =>
  api.get<Permission[]>('Permission/GetList').then((res) => res.data);

export const getPermission = (id: number) =>
  api.get<Permission>(`Permission/GetItem/?id=${id}`).then((res) => res.data);

export const updatePermission = (data: PermissionUpdateRequest) =>
  api.put(`Permission/UpdateItem`, data).then((res) => res.data);

export const createPermission = (data: PermissionCreateRequest) =>
  api.post(`Permission/CreateItem`, data).then((res) => res.data);

export const deletePermission = (id: number) =>
  api.delete<Permission>(`Permission/DeleteItem/?id=${id}`).then();
